import { Injectable } from '@angular/core'
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router'
import { Observable } from 'rxjs/Observable'
import { UserService } from '../user'

@Injectable()
export class AdminGuard implements CanActivate {

	constructor(
		private user: UserService,
		private router: Router,
	) {}

	canActivate(
		next: ActivatedRouteSnapshot,
		state: RouterStateSnapshot,
	): Observable<boolean> | boolean {
		return this.user.admin
			.map(level => level > 0)
			.first()
	}
}



// WEBPACK FOOTER //
// /Users/axel/Sites/Bannerboy/Internal/attaboy-angular/src/app/admin/admin-guard.service.ts